import { render, staticRenderFns } from "./UserNonActive.vue?vue&type=template&id=210c1b1c&scoped=true"
import script from "./UserNonActive.vue?vue&type=script&lang=js"
export * from "./UserNonActive.vue?vue&type=script&lang=js"
import style0 from "./UserNonActive.vue?vue&type=style&index=0&id=210c1b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c1b1c",
  null
  
)

export default component.exports